import { z } from 'zod';

import { ZodBoExportResponse, ZodBoListCsvExportBody } from '@Common/types/bo/exports';
import { ZodId } from '@Common/types/request';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';

/**
 * The employees of the list, as its filters and sort select them, in the bulk create template.
 * `query` is the list query as the list endpoint takes it.
 */
export const ZodEmployeesBulkExportBody = z.object({
  kind: z.literal('employees_bulk'),
  query: ZodBoListCsvExportBody.shape.query,
});
export type EmployeesBulkExportBody = z.infer<typeof ZodEmployeesBulkExportBody>;

/** As `employees_bulk`, in the multi company bulk create template */
export const ZodEmployeesBulkMultiCompanyExportBody = z.object({
  kind: z.literal('employees_bulk_multi_company'),
  query: ZodBoListCsvExportBody.shape.query,
});
export type EmployeesBulkMultiCompanyExportBody = z.infer<
  typeof ZodEmployeesBulkMultiCompanyExportBody
>;

/** The company's employees with their bank details, for a collective out transfer */
export const ZodCollectiveOutTransferAffiliatesExportBody = z.object({
  kind: z.literal('collective_out_transfer_affiliates'),
  company_id: ZodId,
});
export type CollectiveOutTransferAffiliatesExportBody = z.infer<
  typeof ZodCollectiveOutTransferAffiliatesExportBody
>;

export const postB2bEmployeesExportEndpoint = endpoint({
  method: 'POST',
  body: z.discriminatedUnion('kind', [
    ZodEmployeesBulkExportBody,
    ZodEmployeesBulkMultiCompanyExportBody,
    ZodCollectiveOutTransferAffiliatesExportBody,
  ]),
  responseBody: ZodBoExportResponse,
});
export type PostB2bEmployeesExportEndpoint = GetEndpointType<typeof postB2bEmployeesExportEndpoint>;
